const al = {
    vday_modal_title: 'My Vodafone day promo',
    vday_check_button: 'Check it now',
    vday_title: 'Hurry up!',
    vday_description: `Only TODAY – ${'\n'} spend less and get more!`,
    vday_days: 'Days',
    vday_hour: 'Hour',
    vday_minute: 'Min',
    vday_second: 'Sec',
    vday_explore_offers: 'Explore Offers',
    vday_more_info: 'More Info',
    vday_more_info_url: 'https://api-web-ci-vfal.vodafone.com/file/weekend/more_info/MoreInfoWeekendAL.html',
}

export default al
